import { render, staticRenderFns } from "./31.vue?vue&type=template&id=f28fd96e&scoped=true&"
import script from "./31.vue?vue&type=script&lang=js&"
export * from "./31.vue?vue&type=script&lang=js&"
import style0 from "./31.vue?vue&type=style&index=0&id=f28fd96e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28fd96e",
  null
  
)

export default component.exports